module.exports = __webpack_public_path__ + "../resources/img/ic_re_cloudy_solid.b5dee98e.svg";